import { z } from 'zod';
import { yesNoRequired } from '@utils/form-schema';

// Client-side email check; the server (RegexPattern.Email) remains authoritative.
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

// Mirrors AuthLoginModel's ValueConditionalRequired attributes: whichever destination
// the donor picked is the only one required.
export const authLoginSchema = z
    .object({
        isMobile: yesNoRequired,
        email: z.string(),
        mobileNumber: z.string(),
    })
    .superRefine((data, ctx) => {
        const required = (field: keyof typeof data, message = 'Required') => {
            ctx.addIssue({ code: 'custom', path: [field], message });
        };

        if (data.isMobile === '1') {
            if (!data.mobileNumber) {
                required('mobileNumber');
            } else if (!/^\d{10}$/.test(data.mobileNumber)) {
                required('mobileNumber', 'Must be U.S. 10-digits');
            }

            return;
        }

        if (!data.email) {
            required('email');
        } else if (data.email.length > 64) {
            required('email', 'Too Long');
        } else if (!EMAIL_REGEX.test(data.email)) {
            required('email', 'Invalid');
        }
    });
